import { render, staticRenderFns } from "./IcoRow2.vue?vue&type=template&id=1cddc73f"
import script from "./IcoRow2.vue?vue&type=script&lang=js"
export * from "./IcoRow2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports